
export  const open = {
      color :"black"
      };
  
export const closed = {
     color:"white"
      }
  